/**
 * Comprehensive ISO country code mappings (233 countries).
 * Source: countries.parquet (Natural Earth + ISO 3166).
 *
 * Both maps are needed because different data sources use different codes:
 *   - admin_metadata.json, R2 boundaries → ISO-3 (USA, GBR, CHN)
 *   - places.parquet (Overture POIs)     → ISO-2 (US, GB, CN)
 *   - Natural Earth states/cities        → ISO-2 (iso_a2, iso_3166_2)
 */

export const ISO3_TO_ISO2 = {
  ABW: 'AW', AFG: 'AF', AGO: 'AO', AIA: 'AI', ALA: 'AX', ALB: 'AL',
  AND: 'AD', ARE: 'AE', ARG: 'AR', ARM: 'AM', ASM: 'AS', ATA: 'AQ',
  ATF: 'TF', ATG: 'AG', AUS: 'AU', AUT: 'AT', AZE: 'AZ', BDI: 'BI',
  BEL: 'BE', BEN: 'BJ', BFA: 'BF', BGD: 'BD', BGR: 'BG', BHR: 'BH',
  BHS: 'BS', BIH: 'BA', BLM: 'BL', BLR: 'BY', BLZ: 'BZ', BMU: 'BM',
  BOL: 'BO', BRA: 'BR', BRB: 'BB', BRN: 'BN', BTN: 'BT', BWA: 'BW',
  CAF: 'CF', CAN: 'CA', CHE: 'CH', CHL: 'CL', CHN: 'CN', CIV: 'CI',
  CMR: 'CM', COD: 'CD', COG: 'CG', COK: 'CK', COL: 'CO', COM: 'KM',
  CPV: 'CV', CRI: 'CR', CUB: 'CU', CUW: 'CW', CYM: 'KY', CYP: 'CY',
  CZE: 'CZ', DEU: 'DE', DJI: 'DJ', DMA: 'DM', DNK: 'DK', DOM: 'DO',
  DZA: 'DZ', ECU: 'EC', EGY: 'EG', ERI: 'ER', ESH: 'EH', ESP: 'ES',
  EST: 'EE', ETH: 'ET', FIN: 'FI', FJI: 'FJ', FLK: 'FK', FRO: 'FO',
  FSM: 'FM', GAB: 'GA', GBR: 'GB', GEO: 'GE', GGY: 'GG', GHA: 'GH',
  GIN: 'GN', GMB: 'GM', GNB: 'GW', GNQ: 'GQ', GRC: 'GR', GRD: 'GD',
  GRL: 'GL', GTM: 'GT', GUM: 'GU', GUY: 'GY', HKG: 'HK', HMD: 'HM',
  HND: 'HN', HRV: 'HR', HTI: 'HT', HUN: 'HU', IDN: 'ID', IMN: 'IM',
  IND: 'IN', IOT: 'IO', IRL: 'IE', IRN: 'IR', IRQ: 'IQ', ISL: 'IS',
  ISR: 'IL', ITA: 'IT', JAM: 'JM', JEY: 'JE', JOR: 'JO', JPN: 'JP',
  KAZ: 'KZ', KEN: 'KE', KGZ: 'KG', KHM: 'KH', KIR: 'KI', KNA: 'KN',
  KOR: 'KR', KWT: 'KW', LAO: 'LA', LBN: 'LB', LBR: 'LR', LBY: 'LY',
  LCA: 'LC', LIE: 'LI', LKA: 'LK', LSO: 'LS', LTU: 'LT', LUX: 'LU',
  LVA: 'LV', MAC: 'MO', MAF: 'MF', MAR: 'MA', MCO: 'MC', MDA: 'MD',
  MDG: 'MG', MDV: 'MV', MEX: 'MX', MHL: 'MH', MKD: 'MK', MLI: 'ML',
  MLT: 'MT', MMR: 'MM', MNE: 'ME', MNG: 'MN', MNP: 'MP', MOZ: 'MZ',
  MRT: 'MR', MSR: 'MS', MUS: 'MU', MWI: 'MW', MYS: 'MY', NAM: 'NA',
  NCL: 'NC', NER: 'NE', NFK: 'NF', NGA: 'NG', NIC: 'NI', NIU: 'NU',
  NLD: 'NL', NPL: 'NP', NRU: 'NR', NZL: 'NZ', OMN: 'OM', PAK: 'PK',
  PAN: 'PA', PCN: 'PN', PER: 'PE', PHL: 'PH', PLW: 'PW', PNG: 'PG',
  POL: 'PL', PRI: 'PR', PRK: 'KP', PRT: 'PT', PRY: 'PY', PSE: 'PS',
  PYF: 'PF', QAT: 'QA', ROU: 'RO', RUS: 'RU', RWA: 'RW', SAU: 'SA',
  SDN: 'SD', SEN: 'SN', SGP: 'SG', SGS: 'GS', SHN: 'SH', SLB: 'SB',
  SLE: 'SL', SLV: 'SV', SMR: 'SM', SOM: 'SO', SPM: 'PM', SRB: 'RS',
  SSD: 'SS', STP: 'ST', SUR: 'SR', SVK: 'SK', SVN: 'SI', SWE: 'SE',
  SWZ: 'SZ', SXM: 'SX', SYC: 'SC', SYR: 'SY', TCA: 'TC', TCD: 'TD',
  TGO: 'TG', THA: 'TH', TJK: 'TJ', TKM: 'TM', TLS: 'TL', TON: 'TO',
  TTO: 'TT', TUN: 'TN', TUR: 'TR', TUV: 'TV', TZA: 'TZ', UGA: 'UG',
  UKR: 'UA', URY: 'UY', USA: 'US', UZB: 'UZ', VAT: 'VA', VCT: 'VC',
  VEN: 'VE', VGB: 'VG', VIR: 'VI', VNM: 'VN', VUT: 'VU', WLF: 'WF',
  WSM: 'WS', YEM: 'YE', ZAF: 'ZA', ZMB: 'ZM', ZWE: 'ZW',
  // Additional territories sometimes seen in admin_metadata but missing from parquet
  BES: 'BQ', FRA: 'FR', GIB: 'GI', GLP: 'GP', MTQ: 'MQ', MYT: 'YT',
  NOR: 'NO', REU: 'RE', TKL: 'TK', TWN: 'TW',
};

// Reverse map: ISO-2 → ISO-3
export const ISO2_TO_ISO3 = {};
for (const [iso3, iso2] of Object.entries(ISO3_TO_ISO2)) {
  ISO2_TO_ISO3[iso2] = iso3;
}

/**
 * Convert ISO-3 to ISO-2. Returns null if unknown.
 */
export function iso3ToIso2(iso3) {
  if (!iso3) return null;
  return ISO3_TO_ISO2[iso3.toUpperCase()] || null;
}

/**
 * Convert ISO-2 to ISO-3. Returns null if unknown.
 */
export function iso2ToIso3(iso2) {
  if (!iso2) return null;
  return ISO2_TO_ISO3[iso2.toUpperCase()] || null;
}
